import axios from "axios";
import React, { useState,useEffect } from "react";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Col, Row } from "react-bootstrap";
import { Menu, MenuItem, ProSidebar } from "react-pro-sidebar";
import { Link } from "react-router-dom";
const MyBooking = () => {
  const [selectedBooking, setSelectedBooking] = useState(null);
      
  const [vendorModalVisible, setVendorModalVisible] = useState(false);

  const handleVendorView = () => {
      setVendorModalVisible(true);
  };
  
  const [vendors, setVendors] = useState([]);
const [loading, setLoading] = useState(true);
const [error, setError] = useState(null);


// Fetch vendor data from API
useEffect(() => {
  const fetchVendors = async () => {
    try {
      const response = await axios.get('https://vrpmpro.com/api/vendor/getallvendors');
      const sortedVendors = response.data.vendors.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setVendors(sortedVendors);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch vendor data');
      setLoading(false);
      console.error('Error fetching vendor data:', err);
      alert('Error fetching vendor data'); 
    }
  };

  fetchVendors();
}, []); 
  const [show, setShow] = useState(false);
  const [editid, seteditid] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [vehicleTypes, setVehicleTypes] = useState([]);
console.log("vehicletypes,",vehicleTypes);
  const getVehicle = async () => {
    const user = JSON.parse(sessionStorage.getItem("user"));
   console.log("user",user);
   
    const userPhone=user?.phonenumber;
    console.log("userPhone",userPhone);
    
    try {
          let res = await axios.get("https://vrpmpro.com/api/user/bookings");
          if (res.status === 200) {
            console.log("rrr",res.data.success);
            
            // Filter bookings where phone matches the user's phone number
            const filteredData = res.data.success.filter(
              (booking) => String(booking.phone) === String(userPhone)
            );
            
            console.log("filteredData",filteredData);
            setVehicleTypes(filteredData);
          }
      } catch (error) {
          console.log(error);

      }
  }

  useEffect(() => {
      getVehicle();
     
  }, []);

  const customTotal = (from, to, size) => (
      <span className="react-bootstrap-table-pagination-total">
          Showing {from} to {to} of {size} Results
      </span>
  );

  // console.log("vehicleTypes",vehicleTypes);

  const { SearchBar, ClearSearchButton } = Search;
  const { ExportCSVButton } = CSVExport;
  const options = {
      paginationSize: 4,
      pageStartIndex: 0,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      showTotal: true,
      paginationTotalRenderer: customTotal,
      disablePageTitle: true,
      sizePerPageList: [
          {
              text: "5",
              value: 5,
          },
          {
              text: "10",
              value: 10,
          },
          {
              text: "All",
              value: vehicleTypes.length,
          },
      ], // A numeric array is also available. the purpose of above example is custom the text
  };
  const [typeName, setTypeName] = useState("");
  const [description, setDescription] = useState("");
  const [typeImage, setTypeImage] = useState(null);
  const [price, setPrice] = useState("");
  const [gst, setGst] = useState("");
  const [editShow, seteditshow] = useState(false);

  const columns = [
      {
          text: "S.No",
          sort: true,
          formatter: (cell, row, rowIndex) => {
              return (
                  <div>
                      {rowIndex + 1}
                  </div>
              )
          }
      },
      {
          dataField: "customerName",
          text: "Name",
          // formatter: (cell, row, rowIndex) => {
          //     return (
          //         <div>
          //             {row?.typeImage && <img src={`https://vrpmpro.com/vehicletypes/${row?.typeImage}`} style={{ width: "100px", height: "auto", borderRadius: "10px" }} />}
          //         </div>
          //     )
          // }

      },
      {
          dataField: "Number",
          text: "phone",
          formatter: (cell, row, rowIndex) => {
              return (
                  <div>
                     {row?.phone}
                  </div>
              )
          }

      },
      {
          dataField:"setviceType",
          text:"Service Type"
      },
      {
          dataField: "pickupAddress",
          text: "Pickup Address",

      },
      {
          dataField: "deliveryAddress",
          text: "Drop Address",

      },
      {
        dataField: "Cart",
        text: "Item",
        formatter: (cell, row) => {
          console.log("Row Data:", row); 
          return row.Cart?.length > 0
            ? row.Cart.map((item) => item.itemName).join(", ") 
            : "No Items"; 
        }
      },
      {
          dataField: "bookingDate",
          text: "Date",

      },
      {
          dataField: "bookingTime",
          text: "Time",
      },

      {
          dataField: "totalPrice",
          text: " Price",
          sort: true,
      },
      {
          dataField: "status",
          text: "Vendor Status",
          formatter: (cell, row) => {
            return (
              <div>
                <p><strong>Booking Id:</strong> {row._id || "N/A"}</p>
                <p><strong>Vendor Id:</strong> {row?.assignedVendor?.vendorId|| "N/A"}</p>
                <p><strong>Vendor Name:</strong> {row.assignedVendor?.vendorName || "N/A"}</p>
                <p><strong>Vehicle Name:</strong> {row.vehicleType || "N/A"}</p>
                <p><strong>Booking Status:</strong> {row.status || "N/A"}</p>
              </div>
            );
          },
        },
      // {
      //     dataField: "bookingStatus",
      //     text: "Booking Status",
      //     formatter: (cell, row) => {
      //       return (
      //         <div>
      //           <p><strong>Status:</strong> {row.bookingStatus || "N/A"}</p>
      //           <p><strong>Remarks:</strong> {row.bookingStatus || "N/A"}</p>
      //         </div>
      //       );
      //     },
      //   },
      // {
      //     dataField: "assign",
      //     text: "Assign Vendor",
      //     formatter: (cell, row) => (
      //         <button 
      //             className="btn btn-success btn-sm" 
      //             onClick={() => {
      //                 setSelectedBooking(row);
      //                 setVendorModalVisible(true);
      //             }}
      //         >
      //             Assign Vendor
      //         </button>
      //     ),
      // }
      

  ]
  const defaultSorted = [{
      dataField: 'propertytype',
      order: 'desc'
  }];



  const handleImageChange = (e) => {
      setTypeImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
      e.preventDefault();
      let check = vehicleTypes.filter((ele) => ele?.typeName == typeName && ele?.description == description);
      if (check.length != 0) return alert("Type of Vehicle already exits");

      // Prepare form data
      const formData = new FormData();
      formData.append("typeName", typeName);
      formData.append("description", description);
      formData.append("typeImage", typeImage);
      formData.append("price", price);
      formData.append("gst", gst);

      try {
          // Make API call to backend
          const response = await axios.post(
              "https://vrpmpro.com/api/admin/vehicle-types", 
              formData,
              {
                  headers: {
                      "Content-Type": "multipart/form-data", // Important to handle file uploads
                  },
              }
          );
          // Handle response from the API
          console.log(response.data);
          alert("Vehicle type added successfully!");
          handleClose()
          setTypeName('')
          setDescription('');
          setPrice('');
          setGst('');
          setTypeImage("")
          getVehicle()
      } catch (error) {
          // Handle errors
          console.error("Error submitting form", error);
          alert("Error submitting form. Please try again.");
      }
  };

  const handleEdit = async (e) => {
      e.preventDefault();

      let check = vehicleTypes.filter((ele) => ele?.typeName == typeName && ele?.description == description && ele?._id != editid);
      if (check.length != 0) return alert("Type of Vehicle already exits");

      // Prepare form data
      const formData = new FormData();
      formData.append("typeName", typeName);
      formData.append("description", description);
      formData.append("typeImage", typeImage);
      formData.append("price", price);
      formData.append("gst", gst);

      try {
          // Make API call to backend
          const response = await axios.put(
              "https://vrpmpro.com/api/admin/vehicle-types/" + editid, // Replace with your actual API endpoint
              formData,
              {
                  headers: {
                      "Content-Type": "multipart/form-data", // Important to handle file uploads
                  },
              }
          );
          // Handle response from the API
          console.log(response.data);
          alert("Vehicle type updated successfully!");
          seteditshow(false)
          setTypeName('')
          setDescription('');
          setPrice('');
          setGst('');
          setTypeImage("")
          getVehicle()
      } catch (error) {
          // Handle errors
          console.error("Error submitting form", error);
          alert("Error submitting form. Please try again.");
      }
  };


  return (
    <div style={{ background: "#f3f3f3" }}>
    <Row>
    <Col md={3}>
    <ProSidebar>
<Menu iconShape="square">
  <MenuItem >My Account
  <Link to="/profile" />
  </MenuItem>
  <MenuItem active style={{backgroundColor:"#dc3545",fontSize:"18px",color:"white"}} >
  My Booking Details
  <Link to="/mybooking" />
  </MenuItem>
  <MenuItem >Posted Properties
  <Link to="/myproperties" />
  </MenuItem>
  <MenuItem >Change Password
  <Link to="/change_pwd" />
  </MenuItem>
</Menu>

</ProSidebar>
      </Col>
     <Col md={9}>
     <div className="ml-4">
            <h1 className="pt-4 pb-3" style={{ color: "Black" }}>Booking Packer & Mover</h1>
            <div className="container">
                <div className="card card-body">
                    <ToolkitProvider
                        keyField="id"
                        data={vehicleTypes}
                        columns={columns}
                        defaultSorted={defaultSorted}
                        search
                        exportCSV={{
                            fileName: "properties.csv",
                            blobType: "text/csv;charset=ansi",
                        }}
                    >
                        {(props) => (
                            <div>
                                {/* <span className="pr-5 mr-auto">
                                    <ExportCSVButton
                                        className="btn-outline-success"
                                        {...props.csvProps}
                                    >
                                        Export to CSV
                                    </ExportCSVButton>
                                </span>
                                {"     "} */}
                                <span className="ps-5 ml-5 mt-3">
                                    <SearchBar
                                        className="form-control "
                                        {...props.searchProps}
                                    />
                                </span>
                                {"      "}
                                <ClearSearchButton
                                    className="btn-outline-info ms-5 "
                                    {...props.searchProps}
                                />
                                {/* <span className="ps-5 ml-5 mt-3">
                                    <button className='btn btn-outline-danger' onClick={handleShow}>Add Vehicle Type</button>
                                </span> */}

                                <hr />
                                <div className="table-responsive">
                                    <BootstrapTable
                                        keyField="patient"
                                        responsive
                                        hover
                                        columns={columns}
                                        data={vehicleTypes}
                                        pagination={paginationFactory(options)}
                                        {...props.baseProps}
                                    />
                                </div>
                            </div>
                        )}
                    </ToolkitProvider>
                </div>
            </div>
            </div>
     </Col>
      </Row>

   
  </div>
  )
}

export default MyBooking